import 'angular';

import { CashInvoiceService }           from './cash-invoice.service.ajs';
import { EmailInvoiceCtrl  }            from './invoice.email';
import { InvoiceActivityCtrl }          from './invoices.activity';
import { InvoiceActivityLogCtrl }       from './invoice.activity-log';
import { InvoiceAddJobCardNotesCtrl }   from './invoice.update-job-card-notes';
import { InvoiceCreditsCtrl }           from './invoice.credits';
import { InvoiceCreditsDirective }      from './invoice.credits.directive';
import { InvoiceCtrl }                  from './invoice';
import { InvoiceEditCtrl }              from './invoice.edit';
import { InvoiceItemTotalsService }     from './invoice.item-totals.service';
import { InvoiceNewRenewalDatesCtrl }   from './invoice.new-renewal-dates.ajs';
import { InvoicePaymentsCtrl }          from './invoice.payments';
import { InvoicePaymentsDirective }     from './invoice.payments.directive';
import { InvoiceReworkCtrl }            from './invoice.rework';
import { InvoiceSelectionCtrl }         from './invoice.selection';
import { InvoiceService }               from './invoice.service';
import { SplitInvoiceCtrl }             from './invoice.split.ajs';
import { InvoicesStates }               from './invoices.states.ajs';
import { InvoiceTotalsService }         from './invoice.totals.service';
import { InvoiceTradeInCtrl }           from './invoice.trade-in';
import { InvoiceUnitCreditCtrl }        from './invoice.unit-credit';
import { InvoiceUnitSaleCtrl }          from './invoice.unit-sale';
import { InvoiceUpdateUnitCostCtrl }    from './invoice.unit-cost';
import { InvoiceSerialNumbersCtrl }     from './invoice.serial-numbers';
import { OrderingFromInvoiceCtrl }      from './invoice.ordering-from-invoice';

import './deposits/deposits.module.ajs';

angular.module('workshop.invoices', [
  'workshop.invoices.deposits',
]).config(InvoicesStates)
  .controller('addInvoiceJobCardNotes', InvoiceAddJobCardNotesCtrl)
  .controller('EditInvoiceCtrl', InvoiceEditCtrl)
  .controller('EmailInvoiceCtrl', EmailInvoiceCtrl)
  .controller('invoice', InvoiceCtrl)
  .controller('InvoiceActivityCtrl', InvoiceActivityCtrl)
  .controller('InvoiceActivityLogCtrl', InvoiceActivityLogCtrl)
  .controller('InvoiceCreditsCtrl', InvoiceCreditsCtrl)
  .controller('InvoicePaymentsCtrl', InvoicePaymentsCtrl)
  .controller('InvoiceReworkCtrl', InvoiceReworkCtrl)
  .controller('invoiceSelectionCtrl', InvoiceSelectionCtrl)
  .controller('SplitInvoiceCtrl', SplitInvoiceCtrl)
  .controller('UpdateUnitCostCtrl', InvoiceUpdateUnitCostCtrl)
  .controller('NewRenewalDatesCtrl', InvoiceNewRenewalDatesCtrl)
  .controller('orderingFromInvoiceCtrl', OrderingFromInvoiceCtrl)
  .controller('TradeInCtrl', InvoiceTradeInCtrl)
  .controller('UnitCreditCtrl', InvoiceUnitCreditCtrl)
  .controller('UnitSaleCtrl', InvoiceUnitSaleCtrl)
  .controller('InvoiceSerialNumbersCtrl', InvoiceSerialNumbersCtrl)
  .directive('invoiceCredits', InvoiceCreditsDirective)
  .directive('invoicePayments', InvoicePaymentsDirective)
  .factory('Invoice', InvoiceService)
  .factory('InvoiceItemTotals', InvoiceItemTotalsService)
  .factory('InvoiceTotals', InvoiceTotalsService)
  .service('cashInvoiceApi', CashInvoiceService);
